module.exports = __webpack_public_path__ + "img/code_2023.7afea877.jpg";